import { Logo } from "../branding";

export function LoadingScreen() {
	/** Render */
	return (
		<div className="fixed inset-0 flex flex-col justify-end p-8 w-screen h-screen pointer-events-none">
			<Logo
				height="18"
				variant="spinRotation"
			/>
		</div>
	);
}
